<div class="modal-header acm-header">
  <h5 class="modal-title acm-title">
    <i class="las la-filter mr-2"></i>Configurar envíos a dominios externos
  </h5>
  <button type="button" class="close" (click)="dismiss()"><span>&times;</span></button>
</div>

<div class="modal-body acm-body">

  <!-- Tipos de datos sensibles -->
  <div class="acm-section">
    <div class="acm-types-header">
      <div>
        <label class="acm-label mb-0">Tipos de datos sensibles</label>
        <div class="acm-types-hint">Filtra por tipo de dato detectado. Sin selección = todos.</div>
      </div>
      <div class="acm-types-actions">
        <button class="btn btn-link btn-sm p-0" (click)="clearTypes()" [disabled]="loadingTypes">Quitar selección</button>
      </div>
    </div>

    <div *ngIf="loadingTypes" class="acm-loading">
      <div class="spinner-border spinner-border-sm text-primary"></div>
      <span class="ml-2 text-muted">Cargando tipos...</span>
    </div>

    <div *ngIf="!loadingTypes && availableTypes.length === 0" class="text-muted small mt-2">
      Sin datos disponibles para el período actual.
    </div>

    <div *ngIf="!loadingTypes && availableTypes.length > 0" class="acm-types-list">
      <label
        *ngFor="let t of availableTypes"
        class="acm-type-item"
        [class.acm-type-item--selected]="isSelected(t)"
        (click)="toggleType(t)"
      >
        <span class="acm-checkbox">
          <i class="las" [class.la-check-square]="isSelected(t)" [class.la-square]="!isSelected(t)"></i>
        </span>
        <span class="acm-type-name">{{ t }}</span>
      </label>
    </div>
  </div>

  <!-- Exclusión de dominios -->
  <div class="acm-section">
    <label class="acm-label mb-1">
      <i class="las la-ban mr-1" style="font-size:14px;color:#e53e3e"></i>
      Excluir dominios
    </label>
    <div class="acm-types-hint mb-2">Dominios que no deben contarse como envíos externos (ej: dominios del grupo).</div>

    <div class="acm-domain-input-row">
      <input
        type="text"
        class="form-control form-control-sm acm-domain-input"
        placeholder="dominio.com"
        [(ngModel)]="newDomain"
        (keydown)="onDomainKeydown($event)"
      />
      <button class="btn btn-sm btn-outline-primary ml-2" (click)="addDomain()">
        <i class="las la-plus"></i>
      </button>
    </div>
    <div *ngIf="domainError" class="acm-domain-error">{{ domainError }}</div>

    <div *ngIf="excludedDomains.length > 0" class="acm-domain-tags mt-2">
      <span *ngFor="let d of excludedDomains" class="acm-domain-tag">
        <span>{{ d }}</span>
        <button class="acm-domain-remove" (click)="removeDomain(d)">&times;</button>
      </span>
    </div>
    <div *ngIf="excludedDomains.length === 0" class="text-muted small mt-1">
      Sin dominios excluidos.
    </div>
  </div>

</div>

<div class="modal-footer acm-footer">
  <button class="btn btn-sm btn-outline-secondary mr-auto" (click)="reset()">
    <i class="las la-undo mr-1"></i>Quitar filtros
  </button>
  <button class="btn btn-sm btn-outline-dark" (click)="dismiss()">Cancelar</button>
  <button class="btn btn-sm btn-primary" (click)="apply()">
    <i class="las la-check mr-1"></i>Aplicar
  </button>
</div>
